<template>
    <div class="margem pagina-indicadores">
        <div class="filtros-flutuantes">
            <HeaderSelecaoMeses
                :mes="mes"
                :ano="ano"
                @updateMes="atualizarMes"
                @updateAno="atualizarAno"
            />
        </div>

        <BlocoEstrategico :mes="mes" :ano="ano" @updateMes="atualizarMes" />
        <BlocoComercial :mes="mes" :ano="ano" @updateMes="atualizarMes" />
        <BlocoFinanceiro :mes="mes" :ano="ano" @updateMes="atualizarMes" />
        <BlocoProdução :mes="mes" :ano="ano" @updateMes="atualizarMes" />
    </div>
</template>

<script>
import BlocoComercial from '@/components/BlocoComercial.vue';
import BlocoEstrategico from '@/components/BlocoEstrategico.vue';
import BlocoFinanceiro from '@/components/BlocoFinanceiro.vue';
import BlocoProdução from '@/components/BlocoProdução.vue';
import HeaderSelecaoMeses from '@/components/HeaderSelecaoMeses.vue';

export default {
    name: 'GraficosView',
    components: {
        HeaderSelecaoMeses,
        BlocoEstrategico,
        BlocoComercial,
        BlocoFinanceiro,
        BlocoProdução,
    },
    data() {
        return {
            mes: null,
            ano: new Date().getFullYear(),
        };
    },
    methods: {
        atualizarMes(novoMes) {
            this.mes = novoMes;
        },
        atualizarAno(novoAno) {
            this.ano = novoAno;
        },
    },
};
</script>

<style scoped>
.pagina-indicadores {
    padding-top: 1rem;
    padding-bottom: 6rem;
}

.filtros-flutuantes {
    position: fixed;
    top: auto;
    bottom: 1.25rem;
    right: max(1rem, var(--margem, 1.5rem));
    z-index: 50;
}

@media (max-width: 720px) {
    .filtros-flutuantes {
        left: 1rem;
        right: 1rem;
    }

    .pagina-indicadores {
        padding-bottom: 6.5rem;
    }
}
</style>
